import * as React from "react";
const SvgTrash = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 256 256", ...props }, /* @__PURE__ */ React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" }, /* @__PURE__ */ React.createElement("g", { id: "primary" }, /* @__PURE__ */ React.createElement("rect", { x: 48, y: 48, width: 160, height: 24, style: {
  fill: "none",
  stroke: "#414d58",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 16
} }), /* @__PURE__ */ React.createElement("rect", { x: 64, y: 72, width: 128, height: 160, style: {
  fill: "none",
  stroke: "#414d58",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 16
} }), /* @__PURE__ */ React.createElement("rect", { x: 96, y: 24, width: 64, height: 24, style: {
  fill: "none",
  stroke: "#414d58",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 16
} }), /* @__PURE__ */ React.createElement("line", { x1: 112, y1: 200, x2: 112, y2: 152, style: {
  fill: "none",
  stroke: "#414d58",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 16
} }), /* @__PURE__ */ React.createElement("line", { x1: 144, y1: 200, x2: 144, y2: 152, style: {
  fill: "none",
  stroke: "#414d58",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 16
} })), /* @__PURE__ */ React.createElement("g", { id: "frame" }, /* @__PURE__ */ React.createElement("rect", { width: 256, height: 256, style: {
  fill: "none"
} }))));
export default SvgTrash;
